import { getRenNetworkDetails, RenNetwork, } from "@renproject/interfaces";
import { Callable, utilsWithChainNetwork } from "@renproject/utils";
import { EthereumClass } from "./ethereum";
import { addressIsValid } from "./utils";
export const renBscTestnet = {
    name: "BSC Testnet",
    chain: "bscTestnet",
    isTestnet: true,
    chainLabel: "BSC Testnet",
    networkID: 97,
    infura: "https://data-seed-prebsc-1-s1.binance.org:8545",
    // etherscan: "https://explorer.binance.org/smart-testnet",
    etherscan: "https://testnet.bscscan.com",
    addresses: {
        GatewayRegistry: "0x838F881876f53a772D2F8E2f8aa2e4a996431495",
        BasicAdapter: "0x7de1253A8da6620351ec477b38BdC6a55FCd0f85",
    },
};
export const renBscDevnet = {
    ...renBscTestnet,
    addresses: {
        GatewayRegistry: "0x87e83f957a2F3A2E5Fe16d5C6B22e38FD28bdc06",
        BasicAdapter: "0x105435a9b0f375B179e5e43A16228C04F01Fb2ee",
    },
};
export const renBscMainnet = {
    name: "BSC Mainnet",
    chain: "bscMainnet",
    isTestnet: false,
    chainLabel: "BSC Mainnet",
    networkID: 56,
    infura: "https://bsc-dataseed.binance.org/",
    etherscan: "https://bscscan.com",
    addresses: {
        GatewayRegistry: "0x21C482f153D0317fe85C60bE1F7fa079019fcEbD",
        BasicAdapter: "0xAC23817f7E9Ec7EB6B7889BDd2b50e04a44470c5",
    },
};
export const BscConfigMap = {
    [RenNetwork.TestnetVDot3]: renBscTestnet,
    [RenNetwork.MainnetVDot3]: renBscMainnet,
    [RenNetwork.DevnetVDot3]: renBscDevnet,
};
const resolveBSCNetwork = (renNetwork) => {
    if (renNetwork.addresses) {
        return renNetwork;
    }
    else {
        const details = getRenNetworkDetails(renNetwork);
        return details.isTestnet
            ? details.name === RenNetwork.DevnetVDot3
                ? renBscDevnet
                : renBscTestnet
            : renBscMainnet;
    }
};
export class BinanceSmartChainClass extends EthereumClass {
    constructor(web3Provider, renNetwork) {
        // To be compatible with the Ethereum chain class, the first parameter
        // is a web3Provider and the second the RenVM network. However,
        super(web3Provider, resolveBSCNetwork(renNetwork));
        this.chain = BinanceSmartChainClass.chain;
        this.name = BinanceSmartChainClass.chain;
        this.legacyName = undefined;
        this.utils = utilsWithChainNetwork(BinanceSmartChainClass.utils, () => this.renNetworkDetails);
        this.initialize = (renNetwork) => {
            this.renNetworkDetails =
                this.renNetworkDetails ||
                    BscConfigMap[getRenNetworkDetails(renNetwork).name];
            if (!this.renNetworkDetails) {
                throw new Error(`Unable to set ${this.name} network for RenVM network ${getRenNetworkDetails(renNetwork).name}. Please provide ${this.name} network details to ${this.name} constructor.`);
            }
            return this;
        };
    }
}
BinanceSmartChainClass.chain = "BinanceSmartChain";
BinanceSmartChainClass.utils = {
    resolveChainNetwork: resolveBSCNetwork,
    addressIsValid,
    addressExplorerLink: (address, network = renBscMainnet) => `${(BinanceSmartChain.utils.resolveChainNetwork(network) ||
        renBscMainnet).etherscan}/address/${address}`,
    transactionExplorerLink: (transaction, network = renBscMainnet) => `${(BinanceSmartChain.utils.resolveChainNetwork(network) ||
        renBscMainnet).etherscan}/tx/${transaction}`,
};
// @dev Removes any static fields, except `utils`.
export const BinanceSmartChain = Callable(BinanceSmartChainClass);
//# sourceMappingURL=bsc.js.map